var map = {
	"./advisor-blog/whatsapp-icon-desktop-en.png": 1625,
	"./advisor-blog/whatsapp-icon-desktop-zh-HK.png": 1626,
	"./advisor-blog/whatsapp-icon-mobile-en.png": 1627,
	"./advisor-blog/whatsapp-icon-mobile-zh-HK.png": 1628,
	"./ai-assistant/bg-gray-gradient.jpg": 1558,
	"./ai-assistant/bg-gray.png": 1559,
	"./ai-assistant/deco-bottom.jpg": 1497,
	"./ai-assistant/deco-gray.png": 1717,
	"./ai-assistant/deco-left.jpg": 1718,
	"./ai-assistant/deco-left.png": 1563,
	"./ai-assistant/deco-right.jpg": 1719,
	"./ai-assistant/deco-right.png": 1564,
	"./ai-assistant/hero-banner-visual.png": 1720,
	"./ai-assistant/hero-banner.jpg": 1721,
	"./ai-assistant/icon-arrow.png": 1565,
	"./ai-assistant/icon-check.png": 1557,
	"./ai-assistant/icon-coffee.svg": 1554,
	"./ai-assistant/icon-done.png": 1553,
	"./ai-assistant/icon-fav.png": 1567,
	"./ai-assistant/icon-feature-1.png": 1561,
	"./ai-assistant/icon-feature-2.png": 1562,
	"./ai-assistant/img-buildings.png": 1560,
	"./ai-assistant/img-reason-en.png": 1555,
	"./ai-assistant/img-reason-zh.png": 1556,
	"./ai-assistant/img-trade.png": 1566,
	"./auth/email-icon.svg": 483,
	"./auth/fb_icon.png": 1722,
	"./auth/google_icon.png": 1723,
	"./auth/welcome-visual.png": 1724,
	"./back-to-top-button-en.png": 1725,
	"./back-to-top-button-zh-HK.png": 1726,
	"./blog/blog-search-none.svg": 1629,
	"./blog/blog-search-suggest.svg": 1664,
	"./blog/img-sorry-en.png": 1665,
	"./blog/search-icon-white.svg": 1663,
	"./blog/search-icon.svg": 1727,
	"./blog/search-input-image.svg": 1662,
	"./circle-background-desktop.png": 1550,
	"./circle-background-mobile.png": 1552,
	"./close-btn.png": 302,
	"./common/arrow-black.svg": 1498,
	"./common/arrow-green-normal.svg": 1438,
	"./common/arrow-green.svg": 1499,
	"./common/arrow-head-down.svg": 1419,
	"./common/arrow-red-icon.svg": 1666,
	"./common/arrow-right-circle.svg": 1255,
	"./common/arrow-right-white.svg": 1394,
	"./common/arrow-white.png": 1418,
	"./common/back-icon.svg": 1728,
	"./common/back-to-top-button.svg": 496,
	"./common/black-circle-arrow.svg": 1439,
	"./common/circle-green-arrow.png": 1729,
	"./common/circle-green-arrow.svg": 1235,
	"./common/circle-red-arrow.png": 1730,
	"./common/circle-red-arrow.svg": 1347,
	"./common/close.png": 150,
	"./common/close_white.svg": 288,
	"./common/compare-icon-green.svg": 467,
	"./common/compare-icon-white.svg": 466,
	"./common/confirm-button-arrow.png": 291,
	"./common/consultation-circle.png": 1731,
	"./common/consultation-pill.png": 1568,
	"./common/download-white.png": 1014,
	"./common/dropdown-arrow.png": 473,
	"./common/dummy-image.png": 1732,
	"./common/favourite-icon.svg": 1733,
	"./common/filter.png": 1734,
	"./common/goto.png": 1459,
	"./common/icon-checkbox-green.svg": 1348,
	"./common/icon-checkbox-white.svg": 1478,
	"./common/icon-checkbox.svg": 1735,
	"./common/linkedin-icon.svg": 1667,
	"./common/outline-ci.svg": 1736,
	"./common/outline-cross.svg": 1737,
	"./common/outline-saving.svg": 1738,
	"./common/section-header-circle-visual.svg": 1739,
	"./common/share-icon.svg": 1740,
	"./common/tenlife-normal-logo.png": 289,
	"./common/tenlife-white-logo.png": 229,
	"./common/tick-green.png": 1741,
	"./common/tick-red.png": 1742,
	"./common/tick-yellow.png": 1743,
	"./common/tooltip.svg": 1744,
	"./cross-selling-banner-tutorial.png": 1745,
	"./drifter-zone-qr-code-expand.png": 1500,
	"./drifter-zone-qr-code-expand.svg": 1746,
	"./drifter-zone-qr-code-frame.png": 1501,
	"./drifter-zone-qr-code.png": 1502,
	"./drifter-zone-qr-code.svg": 487,
	"./drifter-zone/drifter-zone-wechat-desktop.png": 1548,
	"./drifter-zone/drifter-zone-wechat-mobile.png": 1549,
	"./enquiry/enquiry-fab-en.png": 1747,
	"./enquiry/enquiry-fab-en.svg": 493,
	"./enquiry/enquiry-fab-zh-CN.png": 1748,
	"./enquiry/enquiry-fab-zh-CN.svg": 494,
	"./enquiry/enquiry-fab-zh-HK.png": 1749,
	"./enquiry/enquiry-fab-zh-HK.svg": 495,
	"./error/not_found_visual.png": 472,
	"./error/sorry.png": 471,
	"./fab-close.png": 492,
	"./family/card-bg-desktop.webp": 1569,
	"./family/card-bg-mobile.jpg": 1570,
	"./family/cost-raising-kid-game/baby-smile.svg": 1540,
	"./family/cost-raising-kid-game/bg-line.svg": 1479,
	"./family/cost-raising-kid-game/btn-prev-page.svg": 1668,
	"./family/cost-raising-kid-game/btn-start.svg": 1669,
	"./family/cost-raising-kid-game/campaign-headline-mb.svg": 1571,
	"./family/cost-raising-kid-game/campaign-headline.svg": 1572,
	"./family/cost-raising-kid-game/campaign-logo-green.svg": 1630,
	"./family/cost-raising-kid-game/campaign-logo-s.svg": 1631,
	"./family/cost-raising-kid-game/campaign-logo.svg": 1573,
	"./family/cost-raising-kid-game/campaign-title.svg": 1574,
	"./family/cost-raising-kid-game/child-cry.svg": 1506,
	"./family/cost-raising-kid-game/child-smile.svg": 1395,
	"./family/cost-raising-kid-game/deco-ball.svg": 1670,
	"./family/cost-raising-kid-game/deco-cert.svg": 1575,
	"./family/cost-raising-kid-game/deco-heart-green-bold.svg": 1671,
	"./family/cost-raising-kid-game/deco-heart-green.svg": 1672,
	"./family/cost-raising-kid-game/deco-heart-pink-bold.svg": 1673,
	"./family/cost-raising-kid-game/deco-heart-pink.svg": 1674,
	"./family/cost-raising-kid-game/deco-money-1.svg": 1576,
	"./family/cost-raising-kid-game/deco-money.svg": 1675,
	"./family/cost-raising-kid-game/error-deco.svg": 1577,
	"./family/cost-raising-kid-game/form-title.svg": 1578,
	"./family/cost-raising-kid-game/icon-arrow-left-circle.svg": 1632,
	"./family/cost-raising-kid-game/icon-arrow-right-circle.svg": 1633,
	"./family/cost-raising-kid-game/icon-arrow-right-green.svg": 1579,
	"./family/cost-raising-kid-game/icon-arrow-right-white.svg": 1634,
	"./family/cost-raising-kid-game/icon-arrow-right.svg": 1635,
	"./family/cost-raising-kid-game/icon-close.svg": 1460,
	"./family/cost-raising-kid-game/icon-error.svg": 1541,
	"./family/cost-raising-kid-game/icon-facebook.svg": 1636,
	"./family/cost-raising-kid-game/icon-fly.svg": 1637,
	"./family/cost-raising-kid-game/icon-link.svg": 1638,
	"./family/cost-raising-kid-game/icon-linkedin.svg": 1639,
	"./family/cost-raising-kid-game/icon-plan-child.svg": 1676,
	"./family/cost-raising-kid-game/icon-plan-edu.svg": 1677,
	"./family/cost-raising-kid-game/icon-plan-parent.svg": 1678,
	"./family/cost-raising-kid-game/icon-triangle-down.svg": 1580,
	"./family/cost-raising-kid-game/icon-whatsapp.svg": 1640,
	"./family/cost-raising-kid-game/landing-deco-mb.svg": 1581,
	"./family/cost-raising-kid-game/landing-deco.svg": 1480,
	"./family/cost-raising-kid-game/logo-happy-kids.svg": 1679,
	"./family/cost-raising-kid-game/page-title-form.svg": 1680,
	"./family/cost-raising-kid-game/question-deco-mb.svg": 1507,
	"./family/cost-raising-kid-game/question-deco.svg": 1508,
	"./family/cost-raising-kid-game/text-error-missing-answer.svg": 1582,
	"./family/cost-raising-kid-game/tier1-bg.png": 1481,
	"./family/cost-raising-kid-game/tier1-cost.svg": 1583,
	"./family/cost-raising-kid-game/tier1-happy-score.svg": 1584,
	"./family/cost-raising-kid-game/tier1-more-info.svg": 1585,
	"./family/cost-raising-kid-game/tier1-type.svg": 1586,
	"./family/cost-raising-kid-game/tier1-visual-f.svg": 1641,
	"./family/cost-raising-kid-game/tier1-visual.svg": 1642,
	"./family/cost-raising-kid-game/tier2-bg.png": 1482,
	"./family/cost-raising-kid-game/tier2-cost.svg": 1587,
	"./family/cost-raising-kid-game/tier2-happy-score.svg": 1588,
	"./family/cost-raising-kid-game/tier2-more-info.svg": 1589,
	"./family/cost-raising-kid-game/tier2-type.svg": 1590,
	"./family/cost-raising-kid-game/tier2-visual-f.svg": 1643,
	"./family/cost-raising-kid-game/tier2-visual.svg": 1644,
	"./family/cost-raising-kid-game/tier3-bg.png": 1483,
	"./family/cost-raising-kid-game/tier3-cost.svg": 1591,
	"./family/cost-raising-kid-game/tier3-happy-score.svg": 1592,
	"./family/cost-raising-kid-game/tier3-more-info.svg": 1593,
	"./family/cost-raising-kid-game/tier3-type.svg": 1594,
	"./family/cost-raising-kid-game/tier3-visual-f.svg": 1645,
	"./family/cost-raising-kid-game/tier3-visual.svg": 1646,
	"./family/cost-raising-kid-game/tier4-bg.png": 1484,
	"./family/cost-raising-kid-game/tier4-cost.svg": 1595,
	"./family/cost-raising-kid-game/tier4-happy-score.svg": 1596,
	"./family/cost-raising-kid-game/tier4-more-info.svg": 1597,
	"./family/cost-raising-kid-game/tier4-type.svg": 1598,
	"./family/cost-raising-kid-game/tier4-visual-f.svg": 1647,
	"./family/cost-raising-kid-game/tier4-visual.svg": 1648,
	"./family/deco-corner-left-top.png": 1599,
	"./family/deco-corner-right-bottom.png": 1600,
	"./family/deco-paper-center.png": 1601,
	"./family/deco-paper-left.png": 1602,
	"./family/deco-paper-right.png": 1603,
	"./family/happykids-head-title-mobile.png": 1750,
	"./family/happykids-head-title.png": 1604,
	"./family/icon/axa.png": 1046,
	"./family/icon/baby-verified.png": 1051,
	"./family/icon/comment.png": 1042,
	"./family/icon/critical-filled.png": 1026,
	"./family/icon/critical.png": 1052,
	"./family/icon/cross-black-filled-mobile.png": 1053,
	"./family/icon/cross-black-filled.png": 1027,
	"./family/icon/cross-filled.png": 1028,
	"./family/icon/cross.png": 1054,
	"./family/icon/dollar.png": 1055,
	"./family/icon/education-black-filled-mobile.png": 1056,
	"./family/icon/education-black-filled.png": 1029,
	"./family/icon/education-filled.png": 1030,
	"./family/icon/family-lang-switch.svg": 1275,
	"./family/icon/focus-green-tick.png": 1057,
	"./family/icon/green-stars-circle-solid.svg": 1391,
	"./family/icon/green-tick.png": 1058,
	"./family/icon/green-tick.svg": 1396,
	"./family/icon/happy-kids-home-01-darkgreen.svg": 1420,
	"./family/icon/happy-kids-home-01.svg": 1421,
	"./family/icon/happy-kids-home-02-darkgreen.svg": 1422,
	"./family/icon/happy-kids-home-02.svg": 1423,
	"./family/icon/happy-kids-home-03-darkgreen.svg": 1424,
	"./family/icon/happy-kids-home-03.svg": 1425,
	"./family/icon/hero-dream.png": 1059,
	"./family/icon/hero-dream.svg": 1485,
	"./family/icon/hero-education.png": 1060,
	"./family/icon/hero-education.svg": 1486,
	"./family/icon/hero-health.png": 1061,
	"./family/icon/hero-health.svg": 1487,
	"./family/icon/icon-quote.svg": 1397,
	"./family/icon/img-msg.png": 1043,
	"./family/icon/insurer-company.svg": 1488,
	"./family/icon/money-black-filled-mobile.png": 1062,
	"./family/icon/money-black-filled.png": 1031,
	"./family/icon/money-filled.png": 1032,
	"./family/icon/money.png": 1063,
	"./family/icon/option-ci-filled.png": 1033,
	"./family/icon/option-ci.png": 1064,
	"./family/icon/option-education-funds-filled.png": 1034,
	"./family/icon/option-education-funds.png": 1065,
	"./family/icon/option-health-filled.png": 1035,
	"./family/icon/option-health.png": 1066,
	"./family/icon/option-life-filled.png": 1036,
	"./family/icon/option-life.png": 1067,
	"./family/icon/option-wealth-filled.png": 1037,
	"./family/icon/option-wealth.png": 1068,
	"./family/icon/pregnancy.png": 1069,
	"./family/icon/price-roll.svg": 1489,
	"./family/icon/price-tag.png": 1070,
	"./family/icon/price-tag.svg": 1349,
	"./family/icon/quick-guide.png": 1071,
	"./family/icon/red-tick.png": 1072,
	"./family/icon/shield.svg": 1490,
	"./family/icon/tenlife-verified.png": 1041,
	"./family/icon/term-life-filled.png": 1038,
	"./family/icon/term-life.png": 1073,
	"./family/icon/video-click-button.png": 1016,
	"./family/insurer-head-banner-badge-desktop.png": 1751,
	"./family/insurer-head-banner-badge-mobile.png": 1752,
	"./family/insurer-head-banner-desktop.webp": 1753,
	"./family/insurer-head-banner-mobile.webp": 1754,
	"./family/kids-badge.png": 1461,
	"./family_banner_background.png": 1755,
	"./family_banner_right.png": 1756,
	"./family_banner_right_mobile.png": 1757,
	"./faq/faq_title.png": 1758,
	"./five-star/fulfilment-ratio-tag.png": 1759,
	"./five-star/fulfilment-ratio-tag.svg": 1242,
	"./five-star/outline-ci-black.svg": 1398,
	"./five-star/outline-ci-green.svg": 1440,
	"./five-star/outline-ci-white.svg": 1441,
	"./five-star/outline-ia-black.svg": 1399,
	"./five-star/outline-ia-green.svg": 1442,
	"./five-star/outline-ia-white.svg": 1443,
	"./five-star/outline-life-black.svg": 1400,
	"./five-star/outline-life-green.svg": 1444,
	"./five-star/outline-life-white.svg": 1445,
	"./five-star/outline-medical-black.svg": 1401,
	"./five-star/outline-medical-green.svg": 1446,
	"./five-star/outline-medical-white.svg": 1447,
	"./five-star/outline-qdap-black.svg": 1402,
	"./five-star/outline-qdap-green.svg": 1448,
	"./five-star/outline-qdap-white.svg": 1449,
	"./five-star/outline-saving-black.svg": 1403,
	"./five-star/outline-saving-green.svg": 1450,
	"./five-star/outline-saving-white.svg": 1451,
	"./function-bar/back_to_top_icon.svg": 497,
	"./function-bar/home_icon.svg": 1760,
	"./function-bar/wechat_icon.svg": 491,
	"./function-bar/whatsApp_icon.svg": 489,
	"./homepage-tagging-cta-icon.png": 1761,
	"./insurer-page/Hero_Background_Desktop_v02.webp": 1605,
	"./insurer-page/QDAP-insurance-filled.png": 1462,
	"./insurer-page/QDAP-insurance.png": 1509,
	"./insurer-page/feature-bg-dp.webp": 1606,
	"./insurer-page/feature-bg-m.webp": 1607,
	"./insurer-page/home-insurance-filled.png": 1463,
	"./insurer-page/home-insurance.png": 1510,
	"./insurer-page/immediate-annuity-insurance-filled.png": 1464,
	"./insurer-page/immediate-annuity-insurance.png": 1511,
	"./insurer-page/insurerpagesectionbannerbg-m.png": 1491,
	"./insurer-page/insurerpagesectionbannerbg.png": 1512,
	"./insurer-page/life-insurance-filled.png": 1465,
	"./insurer-page/life-insurance.png": 1513,
	"./insurer-page/long-term-savings-insurance-filled.png": 1466,
	"./insurer-page/long-term-savings-insurance.png": 1514,
	"./insurer-page/medical-insurance-filled.png": 1467,
	"./insurer-page/medical-insurance.png": 1515,
	"./insurer-page/personal-accident-insurance-filled.png": 1468,
	"./insurer-page/personal-accident-insurance.png": 1516,
	"./insurer-page/pet-insurance-filled.png": 1469,
	"./insurer-page/pet-insurance.png": 1517,
	"./insurer-page/short-term-savings-insurance-filled.png": 1470,
	"./insurer-page/short-term-savings-insurance.png": 1518,
	"./insurer-page/term-critical-illness-insurance-filled.png": 1471,
	"./insurer-page/term-critical-illness-insurance.png": 1519,
	"./insurer-page/term-life-insurance-filled.png": 1472,
	"./insurer-page/term-life-insurance.png": 1520,
	"./insurer-page/travel-insurance-filled.png": 1473,
	"./insurer-page/travel-insurance.png": 1521,
	"./insurer-page/whole-life-critical-illness-insurance-filled.png": 1474,
	"./insurer-page/whole-life-critical-illness-insurance.png": 1522,
	"./lead-form/visual.png": 230,
	"./loading.svg": 1762,
	"./logo/10Life_logo-txt_black-bg_transparent.png": 1523,
	"./logo/10life-logo.png": 1763,
	"./mark-close.png": 1547,
	"./mark-open.png": 1546,
	"./media/download-button.png": 1524,
	"./media/media-background-desktop.png": 1681,
	"./media/media-background-mobile.png": 1682,
	"./nav-bar/common/close.svg": 482,
	"./nav-bar/enquiry/fb-icon.svg": 296,
	"./nav-bar/enquiry/ig-icon.svg": 297,
	"./nav-bar/enquiry/linkedin-icon.svg": 298,
	"./nav-bar/enquiry/location.svg": 301,
	"./nav-bar/enquiry/mail.svg": 299,
	"./nav-bar/enquiry/phone.svg": 300,
	"./nav-bar/favourite.svg": 290,
	"./nav-bar/favourite_default.svg": 294,
	"./nav-bar/logout.svg": 478,
	"./nav-bar/logout_default.svg": 477,
	"./nav-bar/my_profile.svg": 476,
	"./nav-bar/my_profile_default.svg": 475,
	"./nav-bar/nav-content/background-visual.svg": 481,
	"./nav-bar/nav-content/goto.svg": 295,
	"./nav-bar/nav_icon.svg": 480,
	"./nav-bar/nav_icon_default.svg": 479,
	"./nav-bar/phone.svg": 1764,
	"./nav-bar/profile.svg": 293,
	"./nav-bar/profile_default.svg": 292,
	"./nav-bar/reset_password.svg": 1765,
	"./nav-bar/reset_password_default.svg": 1766,
	"./nav-bar/search.svg": 1767,
	"./nav-bar/search_default.svg": 1768,
	"./nav-bar/wallet.svg": 1769,
	"./nav-bar/wallet_default.svg": 1770,
	"./products/decoder-icon.svg": 1771,
	"./products/icon-5-stars.png": 1404,
	"./products/icon-compare.svg": 1772,
	"./products/icon-info.svg": 1773,
	"./products/icon-star.svg": 1683,
	"./products/logo-10life-trending.png": 1774,
	"./products/logo-company.png": 1775,
	"./products/product-comparison/comparison_button_disabled.svg": 1236,
	"./products/product-comparison/comparison_button_selected.svg": 1237,
	"./products/product-comparison/comparison_button_unselected.svg": 1238,
	"./products/product-detail/compact-cross.svg": 1358,
	"./products/product-detail/compact-tick.svg": 1359,
	"./products/product-detail/cross.svg": 1023,
	"./products/product-detail/cross_black.svg": 1776,
	"./products/product-detail/cross_for_detail_page.svg": 1525,
	"./products/product-detail/promotion-tag.png": 1777,
	"./products/product-detail/tick.svg": 1024,
	"./products/product-detail/tick_black.svg": 1778,
	"./products/product-detail/tick_for_detail_page.svg": 1526,
	"./products/product-feature/10Life-Trending.png": 1222,
	"./products/product-feature/Decoder-5star-badge.png": 1779,
	"./products/product-feature/Product-Compare.png": 1780,
	"./products/product-feature/campaign-icons/happy-kid.svg": 1243,
	"./products/product-feature/filter-icons/adult_premium_filled.svg": 1426,
	"./products/product-feature/filter-icons/adult_premium_white.svg": 1427,
	"./products/product-feature/filter-icons/age_filled.svg": 1244,
	"./products/product-feature/filter-icons/age_white.svg": 1245,
	"./products/product-feature/filter-icons/annuity_start_age_filled.svg": 1276,
	"./products/product-feature/filter-icons/annuity_start_age_white.svg": 1277,
	"./products/product-feature/filter-icons/avg_premium_filled.svg": 1249,
	"./products/product-feature/filter-icons/avg_premium_white.svg": 1250,
	"./products/product-feature/filter-icons/currency_filled.svg": 1278,
	"./products/product-feature/filter-icons/currency_white.svg": 1279,
	"./products/product-feature/filter-icons/datepicker.svg": 1527,
	"./products/product-feature/filter-icons/datepicker_white.svg": 1392,
	"./products/product-feature/filter-icons/deductible_filled.svg": 1251,
	"./products/product-feature/filter-icons/deductible_white.svg": 1252,
	"./products/product-feature/filter-icons/first_year_premium_filled.svg": 1377,
	"./products/product-feature/filter-icons/first_year_premium_white.svg": 1378,
	"./products/product-feature/filter-icons/gender_filled.svg": 1280,
	"./products/product-feature/filter-icons/gender_white.svg": 1281,
	"./products/product-feature/filter-icons/geographical_coverage_filled.svg": 1282,
	"./products/product-feature/filter-icons/geographical_coverage_white.svg": 1283,
	"./products/product-feature/filter-icons/income_term_filled.svg": 1284,
	"./products/product-feature/filter-icons/income_term_white.svg": 1285,
	"./products/product-feature/filter-icons/issue_age_filled.svg": 1286,
	"./products/product-feature/filter-icons/issue_age_white.svg": 1287,
	"./products/product-feature/filter-icons/multiple_claims_filled.svg": 1288,
	"./products/product-feature/filter-icons/multiple_claims_white.svg": 1289,
	"./products/product-feature/filter-icons/objective_filled.svg": 1290,
	"./products/product-feature/filter-icons/objective_white.svg": 1291,
	"./products/product-feature/filter-icons/occupation_filled.svg": 1292,
	"./products/product-feature/filter-icons/occupation_white.svg": 1293,
	"./products/product-feature/filter-icons/owner_type_filled.svg": 1294,
	"./products/product-feature/filter-icons/owner_type_white.svg": 1295,
	"./products/product-feature/filter-icons/payment_term_filled.svg": 1296,
	"./products/product-feature/filter-icons/payment_term_white.svg": 1297,
	"./products/product-feature/filter-icons/property_age_filled.svg": 1428,
	"./products/product-feature/filter-icons/property_age_white.svg": 1429,
	"./products/product-feature/filter-icons/property_gross_area_filled.svg": 1430,
	"./products/product-feature/filter-icons/property_gross_area_white.svg": 1431,
	"./products/product-feature/filter-icons/property_type_filled.svg": 1298,
	"./products/product-feature/filter-icons/property_type_white.svg": 1299,
	"./products/product-feature/filter-icons/renewal_term_filled.svg": 1300,
	"./products/product-feature/filter-icons/renewal_term_white.svg": 1301,
	"./products/product-feature/filter-icons/risk_preference_filled.svg": 1302,
	"./products/product-feature/filter-icons/risk_preference_white.svg": 1303,
	"./products/product-feature/filter-icons/room_type_filled.svg": 1304,
	"./products/product-feature/filter-icons/room_type_white.svg": 1305,
	"./products/product-feature/filter-icons/smoker_status_filled.svg": 1306,
	"./products/product-feature/filter-icons/smoker_status_white.svg": 1307,
	"./products/product-feature/filter-icons/sort_filled.svg": 1232,
	"./products/product-feature/filter-icons/sort_white.svg": 1308,
	"./products/product-feature/filter-icons/sum_assured_filled.svg": 1253,
	"./products/product-feature/filter-icons/sum_assured_white.svg": 1254,
	"./products/product-feature/filter-icons/target_period_filled.svg": 1309,
	"./products/product-feature/filter-icons/target_period_white.svg": 1310,
	"./products/product-feature/filter-icons/total_premium_filled.svg": 1311,
	"./products/product-feature/filter-icons/total_premium_white.svg": 1312,
	"./products/product-feature/input-hint.svg": 1649,
	"./products/product-feature/tag-icons/annuity_start_age.svg": 1313,
	"./products/product-feature/tag-icons/car_rental.svg": 1314,
	"./products/product-feature/tag-icons/currency.svg": 1315,
	"./products/product-feature/tag-icons/deductible.svg": 1316,
	"./products/product-feature/tag-icons/default.svg": 1317,
	"./products/product-feature/tag-icons/extreme_sport.svg": 1318,
	"./products/product-feature/tag-icons/geographical_coverage.svg": 1319,
	"./products/product-feature/tag-icons/income_term.svg": 1320,
	"./products/product-feature/tag-icons/loss_travel_doc.svg": 1321,
	"./products/product-feature/tag-icons/maturity.svg": 1322,
	"./products/product-feature/tag-icons/mobile.svg": 1323,
	"./products/product-feature/tag-icons/multiple_claims.svg": 1324,
	"./products/product-feature/tag-icons/optional_sum_assured.svg": 1325,
	"./products/product-feature/tag-icons/owner_type.svg": 1326,
	"./products/product-feature/tag-icons/payment_term.svg": 1327,
	"./products/product-feature/tag-icons/physio.svg": 1328,
	"./products/product-feature/tag-icons/plan_type.svg": 1329,
	"./products/product-feature/tag-icons/property_age.svg": 1330,
	"./products/product-feature/tag-icons/property_gross_area.svg": 1331,
	"./products/product-feature/tag-icons/property_type.svg": 1332,
	"./products/product-feature/tag-icons/renewal_term.svg": 1333,
	"./products/product-feature/tag-icons/room_type.svg": 1334,
	"./products/product-feature/tag-icons/sum_assured.svg": 1335,
	"./products/product-feature/tag-icons/target_period.svg": 1336,
	"./products/product-feature/tag-icons/underwriting.svg": 1337,
	"./products/product-listing/deselected-compact-view.svg": 1370,
	"./products/product-listing/deselected-detail-view.svg": 1371,
	"./products/product-listing/selected-compact-view.svg": 1781,
	"./products/product-listing/selected-compact-view2.svg": 1372,
	"./products/product-listing/selected-detail-view.svg": 1782,
	"./products/product-listing/selected-detail-view2.svg": 1373,
	"./products/promotion/side-dot.svg": 1074,
	"./products/promotion/speaker.svg": 1010,
	"./products/test/product-feature/decoder-tutorial.png": 1783,
	"./products/test/product-highlight-visual-container/Image 173.png": 1784,
	"./qdap/magn.svg": 1528,
	"./qdap/qdap-left-arrow-green.svg": 1341,
	"./qdap/qdap-product-card-tag.svg": 1785,
	"./qdap/qdap-right-arrow-green.svg": 1342,
	"./qdap/question-left.svg": 1529,
	"./qdap/question-right.svg": 1530,
	"./qdap/questionnaire/icon-money-saving.svg": 1492,
	"./qdap/questionnaire/icon-pen.svg": 1493,
	"./qdap/questionnaire/icon-price-tag.svg": 1786,
	"./qdap/questionnaire/icon-time.svg": 1684,
	"./qdap/questionnaire/icon-warn.svg": 1494,
	"./qdap/questionnaire/img-error.png": 1432,
	"./qdap/questionnaire/img-start.png": 1531,
	"./qdap/questionnaire/img-start.svg": 1787,
	"./qdap/questionnaire/img-tips.png": 1452,
	"./qdap/questionnaire/img-tips.svg": 1788,
	"./qdap/questionnaire/loading-end.png": 1789,
	"./qdap/questionnaire/loading.png": 1790,
	"./qdap/tax-env.svg": 1532,
	"./quote-end.png": 1685,
	"./quote-start.png": 1686,
	"./tick-black.png": 1551,
	"./tick-green.png": 1219,
	"./tooltip-icon.png": 474,
	"./travel-insurance-feature.png": 1650,
	"./user-center/calendar_icon.png": 1791,
	"./user-center/profile-backdrop.png": 1792,
	"./user-center/upload-image.png": 1793,
	"./wecom/wechat-green.png": 490,
	"./wecom/wechat-qr-avatar.png": 486,
	"./wecom/wechat-qr-frame.png": 484,
	"./wecom/wechat_official_qrcode.jpg": 1794,
	"./wecom/wechat_official_qrcode_1000.png": 1795,
	"./wecom/wechat_official_qrcode_300x300.webp": 485,
	"./whatsapp-fab/whatsapp-btn.png": 1796,
	"./whatsapp-fab/whatsapp-btn.svg": 1797,
	"./whatsapp-fab/whatsapp-green.png": 488,
	"./whatsapp-fab/whatsapp-in-btn.png": 1798,
	"./white-wave.png": 1799
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1248;